// Story 10.5 — `useIsDesktop`: re-render reactivo a cambios de viewport.
// Usa `matchMedia` en lugar de `resize` listener (más eficiente; solo
// dispara cuando cruza el threshold).

import { useEffect, useState } from 'react';

const DEFAULT_MIN_WIDTH = 1024;

export function useIsDesktop(minWidth: number = DEFAULT_MIN_WIDTH): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return true;
    return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(`(min-width: ${minWidth}px)`);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    // matchMedia listeners: Safari ≥14 soporta `addEventListener`. Para
    // entornos viejos hay un fallback a `addListener` (deprecated pero
    // todavía presente en algunos browsers móviles antiguos).
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    type LegacyMql = {
      addListener: (fn: (e: MediaQueryListEvent) => void) => void;
      removeListener: (fn: (e: MediaQueryListEvent) => void) => void;
    };
    const legacy = mql as unknown as LegacyMql;
    legacy.addListener(handler);
    return () => legacy.removeListener(handler);
  }, [minWidth]);

  return matches;
}
